import { applyMiddleware, compose, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import { AppStore } from '../typings/custom-redux';
import reducers from './ducks/reducers';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: Function;
  }
}

const persistedReducer = persistReducer(
  {
    key: 'root',
    storage,
    blacklist: [
      'profilePagePersonalInformation',
      'profilePageGoals',
      'profilePagePreferences',
      'activityCreatePage',
      'examCreatePage',
    ],
  },
  reducers,
);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store: AppStore = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(thunk)),
);

export const persistor = persistStore(store);

/**
 * Algumas vezes é necessário limpar ou modificiar dados salvos pelo redux
 * no localstorage para evitar erros. Sempre que houver alguma modificação na estrutura
 * do state faça isso aqui.
 */
const persistVersion = localStorage.getItem('redux-persist:version');
if (persistVersion !== 'v1.13') {
  persistor.purge();
  localStorage.setItem('redux-persist:version', 'v1.13');
}

export default store;
